/**
 * FlexLink Robot Config API
 * Backend API for Robot Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatternGenerationParameters } from './patternGenerationParameters';
import { PathPlanningParameters } from './pathPlanningParameters';
import { SendToRobotParameters } from './sendToRobotParameters';
import { DbParameters } from './dbParameters';


export interface Settings { 
    fileStoragePath?: string;
    authRealm?: string;
    authServer?: string;
    authClientId?: string;
    licAdminURL?: string;
    sendToRobotParams?: SendToRobotParameters;
    units?: Settings.UnitsEnum;
    /**
     * what public ip address to use in links back to robot config
     */
    externalIpAddress?: string | null;
    /**
     * Show box position ids in pallet debug views
     */
    debugBoxIds?: boolean;
    dbParams?: DbParameters;
    ppParams?: PathPlanningParameters;
    pgParams?: PatternGenerationParameters;
}
export namespace Settings {
    export type UnitsEnum = 'METRIC' | 'IMPERIAL';
    export const UnitsEnum = {
        METRIC: 'METRIC' as UnitsEnum,
        IMPERIAL: 'IMPERIAL' as UnitsEnum
    };
}


